import React from "react";
import { Routes, Route } from "react-router-dom";
import { publicRoutes } from "./routes/allRoutes";
import NonAuthLayout from "./components/NonAuthLayout";
import SuperAdminLayout from "./components/SuperAdminLayout/";

const getLayout = () => {
  return SuperAdminLayout;
};

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
